// extracted by mini-css-extract-plugin
export default {"documentView":"DocumentView_documentView__5TDiw","wrapperRight":"DocumentView_wrapperRight__4oCQt"};